__turbopack_context__.v({
  "active": "AssistantMessage-module__FOJzIW__active",
  "exampleItem": "AssistantMessage-module__FOJzIW__exampleItem",
  "examplesContainer": "AssistantMessage-module__FOJzIW__examplesContainer",
  "examplesHeader": "AssistantMessage-module__FOJzIW__examplesHeader",
  "examplesList": "AssistantMessage-module__FOJzIW__examplesList",
  "fadeIn": "AssistantMessage-module__FOJzIW__fadeIn",
  "feedbackButton": "AssistantMessage-module__FOJzIW__feedbackButton",
  "feedbackContainer": "AssistantMessage-module__FOJzIW__feedbackContainer",
  "footerActions": "AssistantMessage-module__FOJzIW__footerActions",
  "loadingIcon": "AssistantMessage-module__FOJzIW__loadingIcon",
  "loadingMessageContainer": "AssistantMessage-module__FOJzIW__loadingMessageContainer",
  "questionsLibraryButton": "AssistantMessage-module__FOJzIW__questionsLibraryButton",
  "responseDuration": "AssistantMessage-module__FOJzIW__responseDuration",
  "spin": "AssistantMessage-module__FOJzIW__spin",
  "spinner": "AssistantMessage-module__FOJzIW__spinner",
  "suggestionButton": "AssistantMessage-module__FOJzIW__suggestionButton",
  "suggestionsContainer": "AssistantMessage-module__FOJzIW__suggestionsContainer",
  "suggestionsHeader": "AssistantMessage-module__FOJzIW__suggestionsHeader",
  "suggestionsList": "AssistantMessage-module__FOJzIW__suggestionsList",
});
